/**
 * LocationsEmptyState Component
 * Shown when multiple facilities are selected in Step 3
 * Explains that location standards must be configured individually
 * CTA card uses shared information card styles (soft rounded, light blue border/bg).
 */

import React from 'react';
import { Building2, Check } from 'lucide-react';
import {
  INFO_CARD_WRAPPER,
  INFO_CARD_TITLE,
  INFO_CARD_TEXT,
  INFO_CARD_ICON_WRAPPER,
  INFO_CARD_ICON_CLASS,
} from './constants/infoCardStyles';

export const LocationsEmptyState = ({ selectedCount }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[300px] px-8 py-12">
      {/* Icon */}
      <div className="bg-[#61b8e7]/10 rounded-full p-5 mb-6">
        <Building2 className="w-10 h-10 text-[#61b8e7]" />
      </div>

      {/* Title */}
      <h4 className="font-['Roboto:SemiBold',sans-serif] font-semibold text-[18px] text-gray-900 mb-3">
        Area standards are facility-specific
      </h4>

      {/* Description */}
      <p className="font-['Roboto:Regular',sans-serif] text-[15px] text-gray-600 text-center max-w-[420px] leading-relaxed mb-6">
        You&apos;ve selected{' '}
        <span className="font-['Roboto:SemiBold',sans-serif] font-semibold text-[#61b8e7]">
          {selectedCount} facilities
        </span>
        . Each facility has unique areas that require individual configuration.
      </p>

      {/* CTA Card - shared info card style */}
      <div className={`${INFO_CARD_WRAPPER} max-w-[380px] space-y-2`}>
        <p className={INFO_CARD_TITLE}>
          To configure area cleaning standards:
        </p>
        <div className="flex items-start gap-2">
          <div className={INFO_CARD_ICON_WRAPPER}>
            <Check className={INFO_CARD_ICON_CLASS} strokeWidth={4} aria-hidden />
          </div>
          <span className={INFO_CARD_TEXT}>Select a single facility from the list</span>
        </div>
      </div>
    </div>
  );
};
